module.exports = __webpack_public_path__ + "img/cursor-fill.a1fa4952.svg";